import React from "react";

function logo({ box }) {
  return (
    <>
      <div className="box">
        <img src={box} className="box-img" alt="" />
      </div>
    </>
  );
}

export default logo;
